<template>
  <div class="advanced-search mt-h">
    <SearchBox ref="scBox" @searchData='searchFn' :totalNum='totalNum'/>
    <SearchList v-if="searchData.length>0" :searchData='searchData' ref="searchList"/>
    <back-top></back-top>
    <Footer :class="[{'p_bottom':searchData.length == 0 }]" />
  </div>
</template>

<script>
import SearchBox from "./searchchild/SearchBox.vue";
import SearchList from "./searchchild/SearchList.vue";
import BackTop from "@/components/common/backtop/BackTop.vue";

import Footer from "@/components/common/layout/Footer.vue";
import { getSearch } from "@/network/details.js";

export default {
  name: "AdvancedSearch",
  components: {
    SearchBox,
    SearchList,
    Footer,
    BackTop,
  },
  data() {
    return {
      searchData: [],
      totalNum: 0,
      page: 1,
      loading: true,
      init: false,
      params: {
        // page: 1,
        // size: 9,
        // start: "",
        // end: "",
        // key: "",
        // classification: "",
      },
    };
  },
  destroyed() {
    document.removeEventListener("scroll", this.loadMore);
  },
  mounted() {
    document.title = "Search | ShanghaiEye";
    document.addEventListener("scroll", this.loadMore);
    this.searchFn();
  },
  methods: {
    //滚动到底部加载更多
    load() {
      if (this.loading) {
        this.loading = false;
        setTimeout(() => {
          // this.page++;
          this.params.page++;
          // this.$refs.scBox.searchFn();
          getSearch(this.params)
            .then(res => {
              this.searchData = this.searchData.concat(res.data);
              // console.log(this.searchData, "searchData");
              this.totalNum = res.total;
              this.loading = true;
              this.$refs.searchList.handelWidth();
            })
            .catch(res => {
              this.loading = true;
            });
        }, 100);
      }
    },
    //触发滚动
    loadMore() {
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight; //document的滚动高度
      let nowScotop =
        document.documentElement.clientHeight || document.body.clientHeight; //可视区高度
      let wheight =
        document.documentElement.scrollTop || document.body.scrollTop; //已滚动高度
      if (this.loading) {
        if (nowScotop >= scrollHeight - wheight - 100) {
          setTimeout(() => {
            this.load(); //加载列表的请求方法
          }, 100);
        }
      }
    },
    searchFn(data) {
      if (!data) {
        this.params.page = 1;
        return false;
      }
      // console.log(data);
      this.params = data;
      this.searchData = [];
      getSearch(this.params)
        .then(res => {
          this.searchData = this.searchData.concat(res.data);
          // console.log(this.searchData, "searchData");
          this.totalNum = res.total;
          this.loading = true;
        })
        .catch(res => {
          this.loading = true;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.p_bottom {
  position: fixed;
  bottom: 0;
}
</style>